<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port Number</th>
        <th class="text-sm">PPPOE ID</th>
        <th class="text-sm">Status</th>
        <th class="text-sm">Rx Power</th>
        <th class="text-sm">TX Power</th>
        <th class="text-sm">MAC Address</th>
        <th class="text-sm">Vendor</th>
        <th class="text-sm">Distance</th>
        <th class="text-sm">VLAN ID</th>
        <th class="text-sm">Last Update</th>
        <th class="text-sm">Last Dereg Reason</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in ports"
        :key="index"
      >
        <td class="text-sm">{{ item.port_number }}</td>
        <td class="text-sm">
          <span v-if="item.PPPOE_ID && item.PPPOE_ID.length > 20" :title="item.PPPOE_ID">
            {{ item.PPPOE_ID.slice(0, 20) + '...' }}
          </span>
          <span v-else>
            {{ item.PPPOE_ID }}
          </span>
          <span v-if="item.PPPOE_ID" class="d-inline-flex align-items-center" style="gap: 6px; margin-left: 4px;">
            <span class="cursor-pointer" @click="$emit('fetch-graph', item.PPPOE_ID)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#82D616" class="bi bi-graph-up mx-1" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0zm14.293 4.707a1 1 0 0 0-1.414-1.414l-3.182 3.182-2.182-2.182a1 1 0 0 0-1.415 0l-4 4 .708.708 4-4 2.182 2.182a1 1 0 0 0 1.415 0l3.889-3.889z"/>
              </svg>
            </span>
            <span class="cursor-pointer" @click="$emit('confirm-delete', item.id)">
              <i class="fas fa-trash-alt" style="color: red; font-size: 13px;"></i>
            </span>
          </span>
        </td>
        <td class="text-sm">
          <span
            class="badge"
            :class="{
              'bg-success text-white': item.status === 'online' || item.status === 'Online' || item.status === 'finished' || item.status === 'success',
              'bg-danger text-white': item.status === 'error' || item.status === 'offline' || item.status === 'Offline',
              'bg-warning text-white': item.status === 'running',
              'bg-secondary text-white': !['online','Online','finished','success','error','offline','Offline','running'].includes(item.status)
            }"
            style="text-transform: uppercase; color: rgb(255 249 249) !important;"
          >
            {{ item.status }}
          </span>
        </td>
        <td class="text-sm">{{ item.description }}</td>
        <td class="text-sm">{{ item.TXPower }}</td>
        <td class="text-sm cursor-pointer">
          <span v-if="item.mac_address && item.mac_address.length > 20" :title="item.mac_address">
            {{ item.mac_address.slice(0, 20) + '...' }}
          </span>
          <span v-else>
            {{ item.mac_address }}
          </span>
        </td>
        <td class="text-sm">{{ item.vendor }}</td>
        <td class="text-sm">{{ item.distance }}</td>
        <td class="text-sm">{{ item.vlan_id }}</td>
        <td class="text-sm">{{ item.last_update }}</td>
        <td class="text-sm">{{ item.last_dereg_reason }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'OltPortsTable',
  props: {
    ports: {
      type: Array,
      default: () => []
    }
  },
  emits: ['fetch-graph', 'confirm-delete']
}
</script>